import type { IStepStructure, ITrackingConfig, ITrackingStatusInfo, StepStatus, TrackingType } from '../types';

const DEFAULT_STATUS_INFO: ITrackingStatusInfo = {
  stepId: 0,
  subStepId: 0,
  stepStatus: 'notStarted',
  progressLabel: '단계 준비 중',
};

export function getTrackingStatusInfo(config: ITrackingConfig, currentProcess?: string | null): ITrackingStatusInfo {
  if (!currentProcess) return DEFAULT_STATUS_INFO;
  return config.statusMap[currentProcess] ?? DEFAULT_STATUS_INFO;
}

export function isTrackingComplete(config: ITrackingConfig, currentProcess?: string | null): boolean {
  const current = getTrackingStatusInfo(config, currentProcess);
  const finalStep = config.steps[config.steps.length - 1];

  return current.stepId === finalStep?.id && current.stepStatus === 'done';
}

export function getStepStatusOverride(
  trackingType: TrackingType,
  currentProcess?: string | null,
  failReason?: string,
): StepStatus | undefined {
  if (trackingType === 'manual' && currentProcess === 'DOC_PROCESS_STRUCTURING_WORK' && failReason) {
    return 'actionRequired';
  }

  return undefined;
}

export function getStepStructure(
  config: ITrackingConfig,
  currentProcess?: string | null,
  currentStatus?: StepStatus,
): IStepStructure[] {
  const current = getTrackingStatusInfo(config, currentProcess);
  const currentStepStatus = currentStatus ?? current.stepStatus;

  const getStatus = (stepId: number): StepStatus => {
    if (stepId < current.stepId) return 'done';
    if (stepId === current.stepId) return currentStepStatus;
    return 'notStarted';
  };

  const getSubStepStatus = (stepId: number, subStepId: number): StepStatus => {
    if (stepId < current.stepId) return 'done';

    if (stepId === current.stepId) {
      if (subStepId < current.subStepId) return 'done';
      if (subStepId === current.subStepId) return currentStepStatus;
    }

    return 'notStarted';
  };

  return config.steps.map((step) => {
    const stepStatus = getStatus(step.id);
    const subSteps = step.subSteps.map((subStep) => ({
      ...subStep,
      status: getSubStepStatus(step.id, subStep.id),
    }));
    const isAllSubStepsDone = subSteps.length > 0 && subSteps.every((subStep) => subStep.status === 'done');
    const status = isAllSubStepsDone ? 'done' : stepStatus;

    return {
      id: step.id,
      title: step.title,
      description: step.descriptions[status] ?? step.descriptions.inProgress ?? '',
      status,
      subSteps,
    };
  });
}
